<template>
  <vue-modal-custom v-model="modal.visible"
    :header="false"
    :backdrop="false"
    :keyboard="false"
    :footer="false"
    :modalBodyClass="$prefixClass.modal + `-free-used-promotion`">
    <img class="m-b-8" src="../assets/icons/extended-success.svg" />
    <h3 class="m-b-8">{{$t('promotion.extended_success.title')}}</h3>
    <span v-html="$t('promotion.extended_success.description', {plan_name:  store && displayPlanName(store.app_plan).toUpperCase(), time: getDateExpired()})"></span>
    <div class="m-t-20">
      <a-button type="primary" @click="onClose">OK</a-button>
    </div>
  </vue-modal-custom>
</template>

<script>
import { mapGetters } from "vuex";
import { types as typesAuth } from '@/modules/auth/constant'
export default {
  name: 'FreeUsedPromotion',
  props: {
    value: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
    }
  },
  computed: {
    ...mapGetters({
      store: typesAuth.getters.GET_STORE
    }),
    modal: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      }
    }
  },
  methods: {
    onClose() {
      this.modal.visible = false
    },
    getDateExpired() {
      if (!this.store) return;
      let date = new Date(this.store.trial_end)
      return moment(date, "YYYY-MM-DD").format('MMM DD, YYYY');
    }
  }
}
</script>
<style lang="scss">
.#{$modal}-free-used-promotion {
  width: 563px !important;

  .#{$modal} {
    &-close {
      color: $text-color-secondary !important;
    }
    &-body {
      padding: 28px 58px 32px;
      text-align: center;
      .a-btn {
        height: 40px;
      }
    }
  }
}

</style>